import { useSelector } from 'react-redux'
import { ResponsiveComponent } from '../../../common/ResponsiveComponent'
import StatusTag from '../../../common/statusTag'
import { Table } from '../../../common/table'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText } from '../../../helpers/value'

import PropTypes from 'prop-types'
import { mapTableOfRelatedCompanies } from '../constants'
import {
  keyLoading,
  selectLoading,
  selectRelatedCompanyData,
  selectRelatedCompanyIds,
} from '../store/slice'
import { NameCell } from './NameCell'
import { RelationshipGroup } from './RelationshipGroup'

export const RelatedCompanyTable = ({ isDynamicReport }) => {
  const ids = useSelector(selectRelatedCompanyIds)
  const isLoading = useSelector(selectLoading(keyLoading.VIEW_BY))

  return (
    <ResponsiveComponent>
      {(isResponsive) => {
        return (
          <Table
            autoHeightMax={isDynamicReport ? undefined : 200}
            ids={ids}
            isLoading={isLoading}
            isNoDataWithHead={false}
            isDisplayScroll={!isDynamicReport}
            isStickyFirstCol={!isDynamicReport}
            isNoStickyHead={isDynamicReport}
            isDynamicReport={isDynamicReport}
            noDataText="companyAnalysis.ownershipAndGroup.RELATED_COMPANIES_NO_DATA"
            getDataFromRedux={selectRelatedCompanyData}
            schema={Object.values(mapTableOfRelatedCompanies).map((item) => {
              return {
                colId: item.key,
                title: item.title(isResponsive),
                isHtml: true,
                isI18n: true,
                parentThStyle: isDynamicReport ? {} : item.parentThStyle,
                thStyle: item.thStyle,
                render: (val, { rowId }) => {
                  switch (item.key) {
                    case mapTableOfRelatedCompanies.organizationName.key:
                      return (
                        <NameCell
                          rowId={rowId}
                          val={val}
                          isDynamicReport={isDynamicReport}
                        />
                      )

                    case mapTableOfRelatedCompanies.status.key:
                      return (
                        <StatusTag
                          status={val.status}
                          label={val.label}
                          style={{ width: 'fit-content' }}
                        />
                      )

                    case mapTableOfRelatedCompanies.address.key:
                      return isDynamicReport ? (
                        formatText(val)
                      ) : (
                        <TextEllipsisStaticLine
                          lineClamp={2}
                          text={formatText(val)}
                          isI18n={false}
                        />
                      )

                    case mapTableOfRelatedCompanies.relationshipGroup.key:
                      return <RelationshipGroup group={val} />

                    default:
                      return val
                  }
                },
              }
            })}
          />
        )
      }}
    </ResponsiveComponent>
  )
}

RelatedCompanyTable.propTypes = {
  isDynamicReport: PropTypes.bool,
}
